import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, ifEmptyReturn, isEmptyArray, isEmptyVariable} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import RegularDropDown from '../../common/DropdownMenus/RegularDropdown';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-react-dropdowns/styles/material.css";
import { DialogSaveButton } from '../../common/Global/globalStyles.style';
import AlertDialog from '../../common/AlertDialog';
let userDetails = getLocalStorageVariables();
const clientDefaultPlaceholder = "Select Client";
const frameworkDefaultPlaceholder = "Select Framework";

class addFrameworkAccessDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedClientId:"",
            selectedClientPlaceholder:clientDefaultPlaceholder,
            frameworkPlaceholder:frameworkDefaultPlaceholder,
            clientArr:[],
            frameworks:[],
            selectedFrameworkId:[],
            formErrors:{},
            showAlertDialog:false,
            alertDialogMessage:"",
            clientId:"",
            isEdit:false,
            initialValue:{}
        }
        userDetails = getLocalStorageVariables()
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showAddAccessDialog){
            let clientArr = [];
            this.props.clientList.map(item => {
                item["clientAndCity"] = item.companyName + ", " + item.city
                clientArr.push(item);
            })
            this.setState({
                selectedClientId:"",
                selectedClientPlaceholder:clientDefaultPlaceholder,
                frameworkPlaceholder:frameworkDefaultPlaceholder,
                clientArr:clientArr,
                frameworks:this.props.frameworks,
                selectedFrameworkId:[],
                formErrors:{},
                showAlertDialog:false,
                alertDialogMessage:"",
                clientId:"",
                isEdit:false,
                initialValue:{}
            })
        }
    }

    // Handles the selection of a client from the dropdown
    clientDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['client'] = "";
        }

        if(!isEmptyArray(this.props.frameworkAccessList)){
            let list = this.props.frameworkAccessList.filter(e => e.clientId == item.clientId)
            if(!isEmptyArray(list)){
                if(this.state.submitClickedAtleastOnce){
                    FormErrorsTemp['selectedFrameworkId'] = "";
                }

                this.setState({
                    selectedFrameworkId:JSON.parse(list[0].frameworkIds),
                    clientId:list[0].clientId,
                    isEdit:true
                })
            }else{
                this.setState({
                    selectedFrameworkId:[],
                    clientId:"",
                    isEdit:false
                })
            }
        }
        this.setState({
            selectedClientPlaceholder:item.clientAndCity,
            selectedClientId:item.clientId,
            formErrors:FormErrorsTemp
        })
    }

    // Adds the framework ID to the selectedFrameworkId array if it is not empty.
    addSelection = (args) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedFrameworkId'] = "";
        }

        if(!isEmptyVariable(args.itemData.frameworkId)){
            this.state.selectedFrameworkId.push(args.itemData.frameworkId)
        }
        this.setState({
            selectedFrameworkId:this.state.selectedFrameworkId,
            formErrors:FormErrorsTemp
        })
    }

    // Removes the framework ID from the selectedFrameworkId array if it exists.
    removeSelection = (args) => {
        if(!isEmptyVariable(args.itemData.frameworkId)){
            let idx = this.state.selectedFrameworkId.indexOf(args.itemData.frameworkId);
            if(idx !== -1){
                this.state.selectedFrameworkId.splice(idx,1);
            }
        }
        this.setState({
            selectedFrameworkId:this.state.selectedFrameworkId
        })
    }

    // Closes the alert dialog box and resets its message.
    handleAlertDialogClose = () => {
        this.setState({
            showAlertDialog:false,
            alertDialogMessage:""
        })
    }

    handleAddAccessDialogClose = () => {
        this.setState({
            showLoader:false,
            formErrors:{},
            selectedFrameworkId:[],
            clientId:"",
            isEdit:false
        },() => {
            this.props.handleAddAccessDialogClose();
        });
    }

    /*******************API CALLS*******************/
    handleClientAccess = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};
        
        if(isEmptyVariable(this.state.selectedClientId)){
            isError = true;
            FormErrorsTemp['client'] = "Please select client";
        }

        if(isEmptyArray(this.state.selectedFrameworkId)){
            isError = true;
            FormErrorsTemp['selectedFrameworkId'] = "Please select framework";
        }

        if(isError){
            this.setState({
                formErrors: FormErrorsTemp,
                showLoader: false,
            });
        }else{
            let url = "";
            let list = this.props.frameworkAccessList.filter(e => e.clientId == this.state.selectedClientId
                && e.frameworkId == JSON.stringify(this.state.selectedFrameworkId))

            if(!isEmptyArray(list)){
                this.handleAddAccessDialogClose();
            }else{
                let postParam = {
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    clientId:this.state.selectedClientId,
                    frameworkIds:JSON.stringify(this.state.selectedFrameworkId)
                }
    
                if(this.state.isEdit){
                    url = Constants.UpdateFrameworkAccess;
                }else{
                    url = Constants.AddFrameworkAccess;
                }

                fetch(url,
                {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams(postParam)
                })
                .then(response => { return response.json(); } )
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            showLoader:false,
                            formErrors:{},
                            selectedFrameworkId:[],
                            clientId:"",
                            isEdit:false
                        },() => {
                            this.props.handleAddAccessDialogClose(true);
                        });
                    }else{
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage,
                            showLoader:false
                        });
                    }
                });
            }
        }
    }
    /*******************API CALLS END HERE*******************/

    render() {
        let fields = {text:"frameworkName",value:"frameworkId"}
        return(
            <>
                <Modal enforceFocus={false} className="custom-dialog" show={this.props.showAddAccessDialog} onHide={this.handleAddAccessDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>{"Add Framework Access"}</h5>
                        <button 
                            onClick={this.handleAddAccessDialogClose}
                            type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="addnew-modal-form">
                            <div class="addnew-modal-form-group">
                                <p>Client*</p>
                                <RegularDropDown
                                    placeholder={this.state.selectedClientPlaceholder}
                                    dropdownArr={this.state.clientArr}
                                    labelParam="clientAndCity"
                                    onDropDownItemClick={this.clientDropdownClick}
                                    defaultPlaceholderDropDown={clientDefaultPlaceholder}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['client']) &&
                                    <span className="cm-error">{this.state.formErrors['client']}</span>
                                }
                            </div>
                            <div className="addnew-modal-form-group">
                                <p>Framework*</p>
                                <MultiSelectComponent
                                    id="clientCheckbox"
                                    dataSource={this.state.frameworks}
                                    fields={fields}
                                    placeholder={this.state.frameworkPlaceholder} 
                                    mode="CheckBox"
                                    closePopupOnSelect={false}
                                    allowFiltering={true}
                                    select={this.addSelection}
                                    removed={this.removeSelection}
                                    cssClass="clientsChecklist"
                                    value={this.state.selectedFrameworkId}
                                    showDropDownIcon={true}
                                    showClearButton={false}
                                >
                                    <Inject services={[CheckBoxSelection]} />
                                </MultiSelectComponent>
                                {
                                    !isEmptyVariable(this.state.formErrors['selectedFrameworkId']) &&
                                    <span className="cm-error">{this.state.formErrors['selectedFrameworkId']}</span>
                                }
                            </div>
                            <div className="modal-close-save">
                                <div className="close-save-col">
                                    <button onClick={this.handleAddAccessDialogClose} type="button" className="modal-close">Cancel</button>
                                    <DialogSaveButton
                                        themeSettings={this.props.themeSettings}
                                        onClick={this.handleClientAccess} type="button">
                                            Save
                                    </DialogSaveButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <AlertDialog
                    showAlertDialog={this.state.showAlertDialog}
                    handleAlertDialogClose={this.handleAlertDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={this.state.alertDialogHeading}
                    alertDialogMessage={this.state.alertDialogMessage}
                    proceedBtnClick={this.deleteFrameworkInfo}
                    proceedBtnLabel={this.state.proceedBtnLabel}
                    showLoader={this.state.showBtnLoader}
                    themeSettings={this.props.themeSettings}
                />

            </>
        )
    }
}
export default addFrameworkAccessDialog;